import React from 'react';
import { ApMonthPicker } from '@alixpartners/ui-components';
import { MonthPickerBlock, Label } from './styles';
import ClickOutside from 'react-click-outside';

class MonthPicker extends React.Component {
	itemRef = React.createRef();

	// Implementing month picker force close
	// As ApMonthpicker does not explose close api
	handleClickOutside = () => {
		const el = this.itemRef.current;

		if (el) {
			const footerEl = el.getElementsByClassName('ap-button-group')[0];

			if (footerEl) {
				footerEl.getElementsByClassName('ap-button-secondary')[0].click();
			}
		}
	};

	render() {
		const { onClick, srcRange, onConfirm, stateRange, index } = this.props;

		return (
			<ClickOutside onClickOutside={this.handleClickOutside}>
				<MonthPickerBlock innerRef={this.itemRef} onClick={onClick}>
					{index === 0 && <Label>Custom Period</Label>}
					<ApMonthPicker
						srcRange={srcRange}
						onConfirm={onConfirm}
						stateRange={stateRange}
					/>
				</MonthPickerBlock>
			</ClickOutside>
		);
	}
}

export default MonthPicker;
